import { useClient, useMutation } from '@weenat/client'
import { useIntl } from '@weenat/wintl'
import useToasts from 'app/src/hooks/useToasts'
import { TogglePrimitive } from 'app/src/kit/fields/ToggleField'
import { useState } from 'react'
import { styled } from 'styled-components'

const NoMarginToggle = styled(TogglePrimitive)`
  margin: 0 4px 0 0;
`

interface AlertActiveStateToggleProps {
  id: string
  isActive: boolean
  withLabel?: boolean
}

const AlertActiveStateToggle: FC<AlertActiveStateToggleProps> = ({
  id,
  isActive,
  withLabel = true
}) => {
  const client = useClient()
  const { t } = useIntl()
  const { addSuccessToast } = useToasts()

  // necessary state for optimistic updates
  const [isAlertActive, setIsAlertActive] = useState(isActive)

  // Handling alert update
  const [updateAlert, updateAlertState] = useMutation(client.alerts.update()(id), {
    onSuccess: () => {
      addSuccessToast(t('actions.success'))
    }
  })

  return (
    <NoMarginToggle
      onToggle={(_, e) => {
        updateAlert({ isActive: !isAlertActive })
        setIsAlertActive(!isAlertActive)
        e.preventDefault()
      }}
      value={isAlertActive}
      label={
        withLabel
          ? isAlertActive
            ? t('alerts.activated', { capitalize: true })
            : t('alerts.deactivated', { capitalize: true })
          : undefined
      }
      $isDisabled={updateAlertState.isPending}
    />
  )
}

export default AlertActiveStateToggle
